
import Vue from "vue";

export default Vue.extend({
    name: "CookieBarController",
    mounted() {
        const cookieBar: Element | null = document.querySelector('.cookiebar');
        if (cookieBar) {
            const consentForm: Element | null = cookieBar.querySelector('.consent-form');
            if (consentForm) {
                const consentLevel0: HTMLInputElement | null = consentForm.querySelector('#gdpr_consent_level_0');
                const consentLevel1: HTMLInputElement | null = consentForm.querySelector('#gdpr_consent_level_1');
                const consentLevel2: HTMLInputElement | null = consentForm.querySelector('#gdpr_consent_level_2');
                const consentLevel3: HTMLInputElement | null = consentForm.querySelector('#gdpr_consent_level_3');


                const cookieSettingLinks: NodeListOf<Element> = document.querySelectorAll('a[href="#cookie-settings"]');

                [].slice.call(cookieSettingLinks).forEach(function (cookieSettingLink: Element) {
                    cookieSettingLink.addEventListener('click', function (e) {
                        e.preventDefault();
                        cookieBar.classList.add('is-visible');
                    });
                });

                window.addEventListener('gdpr_conditionals_initialized', (e) => {
                    if (window.gdpr) {
                        if (!window.gdpr.cookieWasSet()) {
                            cookieBar.classList.add('is-visible');
                            [consentLevel1, consentLevel2, consentLevel3].forEach((value, index) => {
                                if (value) {
                                    value.checked = true;
                                }
                            });
                        } else {
                            [consentLevel1, consentLevel2, consentLevel3].forEach((value, index) => {
                                if (value) {
                                    if (window.gdpr.isConsentedLevel(index + 1)) {
                                        value.checked = true;
                                    } else {
                                        value.checked = false;
                                    }
                                }
                            });
                        }
                    }
                });

                consentForm.addEventListener('submit', (e) => {
                    e.preventDefault();
                    if (window.gdpr) {
                        [consentLevel1, consentLevel2, consentLevel3].forEach((value, index) => {
                            if (value) {
                                if (value.checked) {
                                    window.gdpr.giveConsentToLevel(index + 1);
                                } else {
                                    window.gdpr.withdrawConsentToLevel(index + 1);
                                }
                            }
                        });
                        window.gdpr.setCookie();
                    }
                    cookieBar.classList.remove('is-visible');
                });
            }
        }


        window.gdpr.handleEventQueue();
    }
})
